import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

const refactorQuicklinks = (data) => {

  const quicklinkArr = data.qlItemsRep ? get(data, 'qlItemsRep', []) : [];

  const quicklinks = quicklinkArr.map(item => {

    const img = item.qlItemsRepImage ? refactorRespImg(item.qlItemsRepImage, [{
      size: 'default',
      key: 'image_size_466x314'
    }]) : null;

    return {
      title: get(item, 'qlItemsRepTitle', null),
      caption: get(item, 'qlItemsRepText', null),
      hrefTitle: get(item, 'qlItemsRepLink.title', null),
      href: get(item, 'qlItemsRepLink.url', null),
      image: img
    }
  })

  return {
    heading: get(data, 'qlHeading', null),
    items: quicklinks
  };

  // GOAL:

  // "data": [
  //   {
  //     "title": "ea eu voluptate commodo Duis",
  //     "caption": "elit cillum Excepteur dolor",
  //     "hrefTitle": "sed dolor ullamco commodo consectetur",
  //     "href": "https://emma.org",
  //     "image": {
  //       "alt": "sint sit",
  //       "sizes": {
  //         "default": {
  //           "width": "252",
  //           "height": "170",
  //           "src": "//unsplash.it/252/170.jpg?random&gravity=center&rand=563793",
  //           "webp": "//unsplash.it/252/170.webp?random&gravity=center&rand=430653"
  //         },
  //         "lg": {
  //           "width": "466",
  //           "height": "314",
  //           "src": "//unsplash.it/466/314.jpg?random&gravity=center&rand=563793",
  //           "webp": "//unsplash.it/466/314.webp?random&gravity=center&rand=430653"
  //         }
  //       }
  //     }
  //   }
  // ]
}

export default refactorQuicklinks